import React from 'react';
import { FlexBox, FlexDirection, AlignItems } from '../../../utils/css-classes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDolly, faBoxOpen, faTruck } from '@fortawesome/free-solid-svg-icons';

// tslint:disable-next-line:import-name
import style from './index.module.css';

export interface ShipmentsSummaryProps {
  unsorted: number | string;
  boxed: number | string;
  onTruck: number | string;
}

// tslint:disable-next-line:function-name
export default function ShipmentsSummary({ unsorted, boxed, onTruck } : ShipmentsSummaryProps) {
  return (
    <div className={style.Summary}>
      <div className={`${FlexBox.FLEX} ${AlignItems.FLEX_START}`}>
        <FontAwesomeIcon icon={faDolly} size="2x" color="var(--danger)" className={style.Icons}/>
        <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} ${style.Descriptions}`}>
          <div className="h5">
            Unsorted ({unsorted})
          </div>
          <p>
            <small>
              Shipments are 'unsorted' until they are put in pallet boxes.
              They can also be added to a truck manually.
            </small>
          </p>
        </div>
      </div>

      <div className={`${FlexBox.FLEX} ${AlignItems.FLEX_START}`}>
        <FontAwesomeIcon icon={faBoxOpen} size="2x" color="var(--info)" className={style.Icons}/>
        <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} ${style.Descriptions}`}>
          <div className="h5">
            Pallet Boxed ({boxed})
          </div>
          <p>
            <small>
              Shipments that have been moved to a pallet box and
              are waiting to be assigned to a delivery truck.
            </small>
          </p>
        </div>
      </div>

      <div className={`${FlexBox.FLEX} ${AlignItems.FLEX_START}`}>
        <FontAwesomeIcon icon={faTruck} size="2x" color="var(--success)" className={style.Icons}/>
        <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} ${style.Descriptions}`}>
          <div className="h5">
            Boxes On Truck ({onTruck})
          </div>
          <p>
            <small>
              Pallet boxes that have been loaded onto a truck in the last 24 hours.
            </small>
          </p>
        </div>
      </div>
    </div>

  );
}
